/**
 * Created by Reda on 11.02.2026.
 */

AdventureExpedition.register_nightparty = function () {
    Harvested.CONFIG.nightparty = this.createExtendedHarvestedConfig();

    cleverapps.tutorial.register(AdvShortTutorialIntroScene("nightparty"));

    CustomerRecipes.nightparty = this.CUSTOMER_RECIPES;

    Spawner.PRIZES.nightparty = [
        { code: "advrock", stage: 0, weight: 2 },
        { code: "advlawn", stage: 1 },
        { code: "advlawn", stage: 2 },
        { code: "advsource0", stage: 1 },
        { code: "advsource0", stage: 2 },
        { code: "advsource0", stage: 4 },
        { code: "advflower", stage: 0 },
        { code: "advflower", stage: 1 },
        { code: "advflower", stage: 2 },
        { code: "advpalmtree", stage: 0 },
        { code: "advpalmtree", stage: 2 },
        { code: "advpalmtree", stage: 5 },
        { code: "advsource1", stage: 0 }
    ];

    Map2d.TILE_MATERIALS.nightparty = {};

    cleverapps.styles.nightparty = {
        warehouseTutorialMinimal: this.WAREHOUSE_TUTORIAL_MINIMAL
    };

    this.sourceAnimations.nightparty = cleverapps.override(cleverapps.clone(this.sourceAnimations.default), {
        advenergy: "hands",
        advrush: "hands",
        exprunes: "hands",
        emeralds: "hands",
        berries: "hands",
        advgift: "hands",
        advreward: "hands",
        advchest: "hands",
        advpile: "hands",
        advfireplace: "hands",
        advrock: "axe",
        advlawn: "machete",
        advsource1: "axe",
        advsource0: "machete",
        advflower: "machete",
        advpalmtree: "pickaxe"
    });

    ["sidequest1", "sidequest2", "sidequest5", "sidequest6", "exprunes1", "exprunes2", "exprunes3", "exprunes4"].forEach((code) => {
        this.sourceAnimations.nightparty[code] = "hands";
    });

    AchievementsConfig.registerExpedition("nightparty", {
        donorQuest: "adv3rpcustomermain4_1"
    });
};

cleverapps.styles.FogTileView["nightparty"] = cleverapps.override(cleverapps.styles.FogTileView["adventure"], {

});

UnitsLibrary.CODES_BY_TAB.nightparty = [
    [],
    [],
    [],
    ["advsource", "advgenerator0"],
    ["advprize", "expredchest"],
    []
];
